export default IconZodiacSagittarius => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-zodiac-sagittarius" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 20l16 -16" />
  <path d="M13 4h7v7" />
  <path d="M6.5 12.5l5 5" />
</svg>`;